import { SVGProps, Ref, forwardRef } from 'react';

export const UserSinglePlusFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.667 9.334a3.333 3.333 0 1 1 0 6.666 3.333 3.333 0 0 1 0-6.666m-.7 2.633H10.47v1.4h1.496v1.503h1.4v-1.503h1.503v-1.4h-1.503V10.47h-1.4z"
                fill="currentColor"
            />
            <path
                d="M6.497 10c.71 0 1.419.082 2.089.267a4.7 4.7 0 0 0-.652 2.4c0 .848.224 1.644.615 2.333H.5c.419-3.725 3.207-5 5.997-5"
                fill="currentColor"
            />
            <path d="M6.495 1c3 0 4 2 4 4s-1 4-4 4-4-2-4-4 1-4 4-4" fill="currentColor" />
        </g>
    </svg>
));
UserSinglePlusFilledSize16Glyph.displayName = 'UserSinglePlusFilledSize16Glyph';
